// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--3lKb8","logo":"social-module--logo--aeTba"};